import {useLocation} from 'react-router-dom';
import useAccessLevels from '../../../hooks/use-access-levels';

/**
 * Platform-aware manage flag for homepage edition mutates.
 */
export default function useCanManageHomepage() {
    const {pathname} = useLocation();
    const {packages} = useAccessLevels();
    const isPhone = pathname.includes('/user-platform/phone-homepage');
    return isPhone
        ? packages.clientPlatform.managePhoneHomepageEditions
        : packages.clientPlatform.manageWebHomepageEditions;
}
